import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3cb25d6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list" }
const _hoisted_2 = { class: "flex1 content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "待合并线索：", -1))
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "flex1 content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "ID：", -1))
const _hoisted_7 = { class: "name" }

import { reactive, ref, computed } from 'vue'
import { Form } from 'ant-design-vue'
import { message as DcMessage } from '@dc-platform/dc-components'
import { salesClueMarge } from '@/api/gucangSales/clueManage'
import type { SalesClueListItem } from '@/typings/api/clueManage'


const __default__ = { name: 'ClueMarge' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['fetch'],
  setup(__props, { expose: __expose, emit: __emit }) {

const useForm = Form.useForm
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const selectedData = ref<SalesClueListItem[]>([])
const dataForm = reactive<{ targetClueId: string; originalIdList: any[] }>({ targetClueId: '', originalIdList: [] })
const formRules = reactive({
  targetClueId: [{ required: true, message: '请指定主线索' }]
})
const { resetFields, validate, validateInfos } = useForm(dataForm, formRules)

const optionsEnum = computed(() => {
  return selectedData.value.map((item) => ({
    label: item.customerName,
    value: item.clueId
  }))
})
const init = (data: SalesClueListItem[]) => {
  selectedData.value = data
  visible.value = true
}

const emit = __emit
const handleOk = () => {
  validate().then(() => {
    loading.value = true
    const list = selectedData.value.filter((item) => item.clueId !== dataForm.targetClueId)
    dataForm.originalIdList = list.map((item: SalesClueListItem) => item.clueId)
    const params = Object.assign({}, dataForm)
    salesClueMarge(params)
      .then(() => {
        DcMessage.success('合并线索成功')
        resetFields()
        visible.value = false
        emit('fetch')
      })
      .finally(() => {
        loading.value = false
      })
  })
}
const handleCancel = () => {
  resetFields()
}

__expose({ init })

return (_ctx: any,_cache: any) => {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_CosModal = _resolveComponent("CosModal")!

  return (_openBlock(), _createBlock(_component_CosModal, {
    visible: visible.value,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
    title: "线索合并后数据将不能恢复，请谨慎操作！",
    width: "750px",
    bodyStyle: { 'max-height': 'calc(100vh - 300px)', 'overflow-y': 'auto' },
    "confirm-loading": loading.value,
    onOk: handleOk,
    onCancel: handleCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_alert, {
        message: "合并后，只保留选择的线索，删除其他的线索；原线索中不重复的联系人均会合并到新线索下。",
        type: "warning",
        "show-icon": ""
      }),
      _createElementVNode("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionsEnum.value, (item, index) => {
          return (_openBlock(), _createElementBlock("li", { key: index }, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("p", {
                class: "name",
                title: item.label
              }, _toDisplayString(item.label), 9, _hoisted_4)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("p", _hoisted_7, _toDisplayString(item.value), 1)
            ])
          ]))
        }), 128))
      ]),
      _createVNode(_component_a_form, { "wrapper-col": { span: 24 } }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, _mergeProps({ label: "合并于主线索" }, _unref(validateInfos).targetClueId), {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: dataForm.targetClueId,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm.targetClueId) = $event)),
                placeholder: "请选择",
                allowClear: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionsEnum.value, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: item.value,
                      value: item.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(`${item.label}(${item.value})`), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }, 16)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible", "bodyStyle", "confirm-loading"]))
}
}

})